// React libraries
import * as React from 'react';
import classnames from 'classnames';
// Custom Styles
import { useStyles } from "./GreyButtonStyles";
// Material-UI Core
import Button from '@mui/material/Button';
export const GreyButton = (props) => {
    const classes = useStyles(props);
    const { onClick, disabled, selected, type } = props;
    const greyButtonClasses = classnames({
        [classes.greyButton]: true,
        [classes.greyButtonLeft]: type === "left",
        [classes.greyButtonRight]: type === "right",
        [classes.greyButtonSelected]: selected,
        [classes.greyButtonDisabled]: disabled,
    });
    return (React.createElement(Button, { className: greyButtonClasses, disabled: disabled, onClick: onClick }, props.children));
};
export default React.memo(GreyButton);
